import React from 'react';
import './EventVenueModal.scss';
import MapImage from 'Pages/EventDetailPage/EventVenueModal/MapImage';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import { Modal } from 'antd';

interface IProps {
  isVisible: boolean;
  venueDetails: Julius.Website.VenueDetailViewModel[];
  onClose: () => void;
}

const EventVenueModal: React.SFC<IProps> = ({
  isVisible, 
  venueDetails,
  onClose,
}) => (
  <Modal
    visible={ isVisible }
    onCancel={ onClose }
    footer={ null }
  >
    <div className='event-venue-modal'>
      { venueDetails.map((v, key) => (
        <div key={ key } className='venue'>
          <div className='venue-title'>
            { v.name }
          </div>
          <div className='venue-address'>
            { v.address && <span>{ v.address }, </span> }
            { v.zipCode && <span>{ v.zipCode } </span> }
            { v.city && <span>{ v.city }</span> }
            { v.websiteurl && 
            <div>
              <FormattedText
                displayName='Hemsida: '
                formattedName='event.venue.homepage'
              />
              <a href={ v.websiteurl } target='_blank'> { v.websiteurl }</a>
            </div>
             }
          </div>
          <MapImage 
            smallMapsUrl={ v.smallMapsUrl } 
            largeMapsUrl={ v.largeMapsUrl } 
            coordinates={ v.coordinates }
          />
          { v.disabilityInfo &&
            <div>
              <FormattedText 
                style='venue-bold'
                displayName='Rullstolsinformation: '
                formattedName='event.venue.disability'
              />
              <div>
                <span>{ v.disabilityInfo }</span>
              </div>
            </div>
          }
          { v.transportInfo &&
            <div>
              <FormattedText 
                style='venue-bold'
                displayName='Transport: '
                formattedName='event.venue.transport'
              />
              <div>
                <span>{ v.transportInfo }</span>
              </div>
            </div>
          }
          { v.extraInfo &&
            <div>
              <FormattedText 
                style='venue-bold'
                displayName='Övrigt: '
                formattedName='event.venue.extra'  
              />
              <div>
                <span>{ v.extraInfo }</span>
              </div>
            </div>
          }
        </div>
        ),
      ) }
    </div>
  </Modal>
);

export default EventVenueModal;


// WEBPACK FOOTER //
// ./src/pages/EventDetailPage/EventVenueModal/EventVenueModal.tsx